import { useEffect } from "react";
import packageJson from "../../../package.json";

// AIDEIA Sprint S1: banner "Nova versão" desabilitado.
// Mantemos o efeito colateral de sincronizar localStorage.version pra evitar
// que o backend pense que o cliente está desatualizado, mas sem UI.
const VersionControl = () => {
  useEffect(() => {
    try {
      const current = window.localStorage.getItem("version");
      if (current !== packageJson.version) {
        window.localStorage.setItem("version", packageJson.version);
      }
    } catch (_) { /* localStorage indisponível: ignora */ }
  }, []);

  return null;
};

export default VersionControl;

